/**
 * data structure:
 * JSON.stringify({
 *   qrCode: string,
 * })
 */
const DEVICE_QR_CODE_CACHE_KEY = 'dq'

const answerOfEverything = 42

/**
 * @param str
 */
const obfuscate = (str: string): string => {
  return [...str]
    .map((char) => {
      return String.fromCodePoint((char.codePointAt(0) as number) ^ answerOfEverything)
    })
    .join('')
}
const deobfuscate = obfuscate

export function getDeviceQrCodeCache(): string | null {
  // returns null if deserialization fails
  const cachedData = localStorage.getItem(DEVICE_QR_CODE_CACHE_KEY)
  if (!cachedData) {
    return null
  }
  try {
    const { qrCode } = JSON.parse(deobfuscate(cachedData))
    return qrCode
  } catch (error) {
    return null
  }
}

export function setDeviceQrCodeCache(qrCode: string): void {
  try {
    localStorage.setItem(DEVICE_QR_CODE_CACHE_KEY, obfuscate(JSON.stringify({ qrCode })))
  } catch (error) {
    console.error(error)
  }
}
